export const blockIconsToggleStarBorderPurple500 = (
	<span className='material-symbols-outlined'>star_border_purple500</span>
);
